import {
	EmptySubHeader,
	Container,
	Header,
} from '@dealstack/frontend/shared/components/Audit/EmptyAudits/styled.ts';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const EmptyAudits = () => {
	const tCapManage = useTranslationCapManage();

	return (
		<Container>
			<Header>{tCapManage('transactions.details.no_history')}</Header>
			<EmptySubHeader>
				{tCapManage('transactions.details.no.history.description')}
			</EmptySubHeader>
		</Container>
	);
};
